import React from 'react';
import { useTranslation } from 'react-i18next';

import { ModalAction } from "components/commons/Modals";

interface ICallbackCard {
    Icon: React.FC<{fill: string}>,
    title: string,
    colors: {from: string, to: string},
    description: string,
    buttonText?: string,
    separator?: string,
    Form: React.FC<{callbackId?: string, setModalOpen: React.Dispatch<React.SetStateAction<boolean>>}>,
    callbackId?: string
}

const CardBookkeeping: React.FC<ICallbackCard> = ({
    Icon,
    title,
    colors,
    description,
    buttonText = "Send Callback",
    separator,
    Form,
    callbackId = "callback"
}) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { t } = useTranslation();

  const setModalOpenHandler = (e: React.MouseEvent) => {
      e.stopPropagation();
      setModalOpen(true)
  }

  return (
    <>
      <div 
        className="cursor-pointer bg-white shadow-lg rounded-sm border border-gray-200 hover:border-gray-300 shadow-sm transition-all"
        onClick={setModalOpenHandler}
        >
        <div className="flex flex-col h-full p-5">
          <div className="flex-grow">
            <header className="flex items-center mb-4">
              <div 
                className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 mr-3`}
              >
                <Icon fill="#1F55A1" />
              </div>
              <h3 className="text-base text-gray-800 text-left font-semibold">
                {t(title, { ns: 'messages' })}
              </h3>
            </header>
            <div className="text-sm text-left w-10/12 text-black">{t(description)}</div>
          </div>
          <footer className="mt-4">
            <div className="flex flex-wrap justify-between items-center">
              <button className="btn-sm border-gray-200 hover:border-gray-300 shadow-sm flex items-center">
                <span className="text-[#1f55a1]">
                  {t(buttonText, { ns: 'promo' })}
                </span>
              </button>
            </div>
          </footer>
        </div>
      </div>
      <ModalAction 
        description={t(description)} 
        image={<Icon fill="#1F55A1" />} 
        id="company-registartion" 
        modalOpen={modalOpen} 
        setModalOpen={setModalOpen} 
        title={t(title)}
        customSize={'max-w-lg min-w-[500px]'}
      >
        <Form 
          setModalOpen={setModalOpen}
          callbackId={callbackId} 
        />
      </ModalAction>
    </>
  );
}

export default CardBookkeeping;
